// TODO mit RequestStatusEnum zusammenführen un dimmer mit PHP Enum abgleichen!!!

export enum ProcessStatusEnum {
	UNKNOWN = 'UNKNOWN',
	NEW = 'NEW',
	REVIEW = 'REVIEW',
	YOUSIGN_LORENZ = 'YOUSIGN_LORENZ',
	YOUSIGN_PARTNER = 'YOUSIGN_PARTNER',
	SIGNED = 'SIGNED',
	CANCELED = 'CANCELED',
	DECLINED = 'DECLINED'
}
